import ACCEPT_BUTTON from './ACCEPT_BUTTON.json';
import ADD_CLAIM_BUTTON from './ADD_CLAIM_BUTTON.json';
import CANCEL_BUTTON from './CANCEL_BUTTON.json';
import CONDITIONALLY_ACCEPT_BUTTON from './CONDITIONALLY_ACCEPT_BUTTON.json';
import JOB_COMPLETE_BUTTON from './JOB_COMPLETE_BUTTON.json';
import REJECT_BUTTON from './REJECT_BUTTON.json';
import RESCHEDULE_BUTTON from './RESCHEDULE_BUTTON.json';
import SERVICE_COMPLETE_BUTTON from './SERVICE_COMPLETE_BUTTON.json';
import SERVICE_JOB_DISPATCH_BUTTON from './SERVICE_JOB_DISPATCH_BUTTON.json';
import SERVICE_JOB_UPDATE_BUTTON from './SERVICE_JOB_UPDATE_BUTTON.json';
import ADD_CLAIM_BUTTON_FOOD_LOSS from './ADD_CLAIM_BUTTON_FOOD_LOSS.json';
import SERVICE_JOB_SCHEDULE_DISPATCH_BUTTON from './SERVICE_JOB_SCHEDULE_DISPATCH_BUTTON.json';

const formButtonSchemas = {
  SERVICE_JOB_SCHEDULE_DISPATCH_BUTTON,
  ADD_CLAIM_BUTTON_FOOD_LOSS,
  ACCEPT_BUTTON,
  ADD_CLAIM_BUTTON,
  CANCEL_BUTTON,
  CONDITIONALLY_ACCEPT_BUTTON,
  JOB_COMPLETE_BUTTON,
  REJECT_BUTTON,
  RESCHEDULE_BUTTON,
  SERVICE_COMPLETE_BUTTON,
  SERVICE_JOB_DISPATCH_BUTTON,
  SERVICE_JOB_UPDATE_BUTTON,
};

export default formButtonSchemas;
